import { Injectable } from "@angular/core";
import type { ContentBlockKind, BlockRenderConfig } from "../model/block.types";

/**
 * Determines how a content block should be rendered based on its kind and tool_name.
 * Returns a BlockRenderConfig with renderMode, placementType, and debugOnly flag.
 */
@Injectable({ providedIn: "root" })
export class RenderModeRegistry {
  /**
   * Returns the render configuration for a block.
   * @param kind - The block kind from the backend envelope.
   * @param toolName - Optional tool name (only relevant for mcp_tool and tool_frontend kinds).
   */
  getConfig(kind: ContentBlockKind, toolName?: string): BlockRenderConfig {
    switch (kind) {
      case "tool_frontend":
        return {
          renderMode: "silent",
          placementType: "inline",
          debugOnly: toolName === "search_layer",
        };

      case "api_endpoint":
      case "background_job":
      case "plan":
        return {
          renderMode: "card",
          placementType: "grid",
          debugOnly: false,
        };

      default:
        return {
          renderMode: "card",
          placementType: "grid",
          debugOnly: false,
        };
    }
  }
}
